export enum FilterOptionValue {
  ALL,
  PROCESS,
  NEWS,
  WIKI,
  PEOPLE,
  ELEARNING,
}
